export default "__VITE_ASSET__CtsF_8h$__"